RivalIQ.apps.Registration.module('utils', function (utils, App, Backbone, Marionette, $, _) {

    'use strict';

    function passwordNotMinLength(str) {
        return (str.length < 8);
    }

    function onlyDigitsAndWhitespace(str) {
        return str.match(/^[0-9\s]+$/);
    }

    utils.validateNameAndPassword = function (adminCreated, firstname, lastname, companyname, companytitle, password, passwordConfirmation, termsAndConditions) {
        const errors = [];


        if (!$.trim(firstname) || onlyDigitsAndWhitespace(firstname)) {
            errors.push('firstname');
        }

        if (!$.trim(lastname) || onlyDigitsAndWhitespace(lastname)) {
            errors.push('lastname');
        }

        if (adminCreated) {
            if (!$.trim(companyname) || onlyDigitsAndWhitespace(companyname)) {
                errors.push('companyname');
            }

            if (!$.trim(companytitle) || onlyDigitsAndWhitespace(companytitle)) {
                errors.push('companytitle');
            }

            if (termsAndConditions === 'off') {
                errors.push('termsAndConditions');
            }
        }

        if (!password || passwordNotMinLength(password)) {
            errors.push('password');
        }

        if (password !== passwordConfirmation) {
            errors.push('passwordConfirmation');
        }

        return errors;
    };

}, window.moment, window.s);
